import React from 'react';
import styled from 'styled-components';
import { MissionHistoryFilters } from '../../types/missionHistory';

const FiltersContainer = styled.div`
  background: var(--legacy-card-bg);
  border: 1px solid #00d4ff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
`;

const FiltersGrid = styled.div`
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
`;

const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 200px;
`;

const FilterLabel = styled.label`
  color: #00d4ff;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
`;

const FilterInput = styled.input`
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid #333;
  border-radius: 4px;
  padding: 8px 12px;
  color: #fff;
  font-size: 14px;
  font-family: 'Orbitron', monospace;

  &:focus {
    outline: none;
    border-color: #00d4ff;
    box-shadow: 0 0 5px rgba(0, 212, 255, 0.3);
  }

  &::placeholder {
    color: #666;
  }
`;

const FilterSelect = styled.select`
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid #333;
  border-radius: 4px;
  padding: 8px 12px;
  color: #fff;
  font-size: 14px;
  font-family: 'Orbitron', monospace;

  &:focus {
    outline: none;
    border-color: #00d4ff;
    box-shadow: 0 0 5px rgba(0, 212, 255, 0.3);
  }

  option {
    background: #1a232e;
    color: #fff;
  }
`;

const FilterActions = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
`;

const ActionButton = styled.button<{ $variant?: 'primary' | 'secondary' }>`
  background: ${props => props.$variant === 'primary' ? '#00d4ff' : 'transparent'};
  color: ${props => props.$variant === 'primary' ? '#000' : '#00d4ff'};
  border: 1px solid #00d4ff;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 12px;
  font-weight: 500;
  font-family: 'Orbitron', monospace;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: ${props => props.$variant === 'primary' ? '#0099cc' : 'rgba(0, 212, 255, 0.1)'};
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

interface MissionHistoryFiltersProps {
  filters: MissionHistoryFilters;
  onFiltersChange: (filters: MissionHistoryFilters) => void;
  onApplyFilters: () => void;
  onClearFilters: () => void;
}

const MissionHistoryFiltersComponent: React.FC<MissionHistoryFiltersProps> = ({
  filters,
  onFiltersChange,
  onApplyFilters,
  onClearFilters
}) => {
  const handleFilterChange = (field: keyof MissionHistoryFilters, value: any) => {
    onFiltersChange({
      ...filters,
      [field]: value
    });
  };

  const formatDateForInput = (date?: Date): string => {
    if (!date) return '';
    return date.toISOString().split('T')[0];
  };

  const handleDateChange = (field: 'specificDate', value: string) => {
    const date = value ? new Date(value) : undefined;
    handleFilterChange(field, date);
  };

  return (
    <FiltersContainer>
      <FiltersGrid>
        <FilterGroup>
          <FilterLabel>Specific Date</FilterLabel>
          <FilterInput
            type="date"
            value={formatDateForInput(filters.specificDate)}
            onChange={(e) => handleDateChange('specificDate', e.target.value)}
          />
        </FilterGroup>


      </FiltersGrid>

      <FilterActions>
        <ActionButton $variant="secondary" onClick={onClearFilters}>
          Clear Filters
        </ActionButton>
        <ActionButton $variant="primary" onClick={onApplyFilters}>
          Apply Filters
        </ActionButton>
      </FilterActions>
    </FiltersContainer>
  );
};

export default MissionHistoryFiltersComponent;